import { useEffect } from "react"
import { motion } from "framer-motion"

export default function PhotoModal({ children, isOpen, closeModal, focusRef, photo }) {
  // close modal on ESC key press
  useEffect(() => {
    const escFunction = (event) => event.keyCode === 27 && closeModal()
    document.addEventListener("keydown", escFunction, false)
    return () => document.removeEventListener("keydown", escFunction, false)
  }, [closeModal])

  return isOpen ? (
    <>
      <div
        onClick={() => closeModal()}
        className="overlay fixed w-full h-full top-0 left-0 right-0 bottom-0 z-[9998] bg-black bg-opacity-50"
      />
      <div
        tabIndex={0}
        ref={focusRef}
        className="modal w-full max-w-2xl fixed bg-none px-6 max-h-[100dvh] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[9999]"
      >
        <button
          onClick={() => closeModal()}
          aria-label="Close Modal"
          title="Close Modal"
          className="z-30 absolute -top-4 right-0 rounded-full bg-white"
        >
          <motion.svg
            width="50"
            height="50"
            viewBox="0 0 60 60" // Increased viewBox for padding
            initial="hidden"
            animate="visible"
            className="hover:rotate-90 duration-200 stroke-green-a11y"
          >
            <motion.line
              x1="15"
              y1="15"
              x2="45"
              y2="45"
              strokeWidth="4"
              variants={{
                hidden: { pathLength: 0, opacity: 0 },
                visible: (i) => {
                  const delay = 0.25
                  return {
                    pathLength: 1,
                    opacity: 1,
                    transition: {
                      pathLength: { delay, type: "spring", duration: 0.5, bounce: 0 },
                      opacity: { delay, duration: 0.01 },
                    },
                  }
                },
              }}
              custom={2}
            />
            <motion.line
              x1="15"
              y1="45"
              x2="45"
              y2="15"
              strokeWidth="4"
              variants={{
                hidden: { pathLength: 0, opacity: 0 },
                visible: (i) => {
                  const delay = 0.4
                  return {
                    pathLength: 1,
                    opacity: 1,
                    transition: {
                      pathLength: { delay, type: "spring", duration: 0.5, bounce: 0 },
                      opacity: { delay, duration: 0.01 },
                    },
                  }
                },
              }}
              custom={2.5}
            />
          </motion.svg>
        </button>

        <div className="h-auto lg:h-auto w-full flex items-center lg:block rounded-4xl">{children}</div>
      </div>
    </>
  ) : null
}
